<template>
  <div class="dashboard-container">
    <!-- 账号管理 -->
    <div class="dashboard-section">
      <div class="section-header">
        <i class="section-icon"></i>
        <h3 class="section-title">账号管理</h3>
      </div>
      <div class="button-group">
        <el-button 
          class="dashboard-btn" 
          type="primary" 
          plain 
          @click="$router.push('/user/list')">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </el-button>
        <el-button 
          class="dashboard-btn" 
          type="primary" 
          plain 
          @click="$router.push('/permission/roles')">
          <i class="el-icon-coordinate"></i>
          <span>角色管理</span>
        </el-button>
        <el-button 
          class="dashboard-btn" 
          type="primary" 
          plain 
          @click="$router.push('/permission/assign')">
          <i class="el-icon-unlock"></i>
          <span>权限分配</span>
        </el-button>
      </div>
    </div>
    
    
    <!-- 桥梁管理 -->
    <div class="dashboard-section">
      <div class="section-header">
        <i class="section-icon"></i>
        <h3 class="section-title">桥梁管理</h3>
      </div>
      <div class="button-group">
        <el-button 
          class="dashboard-btn" 
          type="primary" 
          plain 
          @click="$router.push('/bridge/list')">
          <i class="el-icon-guide"></i>
          <span>桥梁管理</span>
        </el-button>
        <el-button
          class="dashboard-btn"
          type="primary"
          plain
          @click="$router.push('/equipment-all')">
          <i class="el-icon-cpu"></i>
          <span>设备管理</span>
        </el-button>
        <!-- 监控管理（暂未实现，隐藏）
        <el-button
          class="dashboard-btn"
          type="primary"
          plain
          @click="$router.push('/bridge/monitor')">
          <i class="el-icon-video-camera"></i>
          <span>监控管理</span>
        </el-button>
        -->
        <!-- 桥梁报警（暂未实现，隐藏）
        <el-button
          class="dashboard-btn"
          type="primary"
          plain
          @click="$router.push('/bridge/alerts')">
          <i class="el-icon-warning-outline"></i>
          <span>桥梁报警</span>
        </el-button>
        -->
      </div>
    </div>
    
    <!-- 船舶管理 -->
    <div class="dashboard-section">
      <div class="section-header">
        <i class="section-icon"></i>
        <h3 class="section-title">船舶管理</h3>
      </div>
      <div class="button-group">
        <el-button 
          class="dashboard-btn" 
          type="primary" 
          plain 
          @click="$router.push('/vessel/list')">
          <i class="el-icon-ship"></i>
          <span>船舶管理</span>
        </el-button>
        <el-button
          class="dashboard-btn"
          type="primary"
          plain
          @click="$router.push('/ship/track')">
          <i class="el-icon-position"></i>
          <span>船舶航迹</span>
        </el-button>
        <!-- 船舶报警（暂未实现，隐藏）
        <el-button
          class="dashboard-btn"
          type="primary"
          plain
          @click="$router.push('/ship/alerts')">
          <i class="el-icon-warning-outline"></i>
          <span>船舶报警</span>
        </el-button>
        -->
      </div>
    </div>
    
    <!-- 系统设置 -->
    <div class="dashboard-section">
      <div class="section-header">
        <i class="section-icon"></i>
        <h3 class="section-title">系统设置</h3>
      </div>
      <div class="button-group">
        <el-button 
          class="dashboard-btn" 
          type="primary" 
          plain 
          @click="$router.push('/settings/system-params')">
          <i class="el-icon-setting"></i>
          <span>系统参数</span>
        </el-button>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'HomeDashboard',
  data() {
    return {}
  }
}
</script>

<style scoped>
.dashboard-container {
  padding: 15px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 100px);
}

.dashboard-section {
  background-color: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.section-icon {
  font-size: 22px;
  margin-right: 10px;
  color: #409EFF;
}

.section-title {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #303133;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.dashboard-btn {
  height: 46px;
  padding: 0 20px;
  border-radius: 4px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  width: auto;
}

.dashboard-btn i {
  font-size: 20px;
  margin-right: 8px;
  transition: all 0.3s;
}

.dashboard-btn span {
  font-size: 14px;
  font-weight: 500;
}

.dashboard-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dashboard-btn:hover i {
  animation: pulse 0.5s;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style> 